import { Product } from "@/types/product";
import { stripNonAlphaNumeric } from "@/helpers/strings";
import { getTextFromTranslations } from "@/helpers/translation";

const filterProductsBySearchInput = (products: Product[], searchInput: string): Product[] => {
  const searchInputLowerCase = stripNonAlphaNumeric(searchInput.toLowerCase());
  const searchInputWords = searchInputLowerCase.split(" ");

  return products.filter((product) => {
    const translationName =
      getTextFromTranslations(product.translations) ?? product.translations[0];
    const productNameLowerCase = stripNonAlphaNumeric(translationName.name.toLowerCase());

    const translationTags =
      getTextFromTranslations(product.translations, { nameIsOptional: true }) ?? translationName;
    return (
      searchInputWords.every(
        (word) =>
          productNameLowerCase.includes(word) ||
          translationTags.tags?.findIndex((tag) => tag.toLowerCase().includes(word)) !== -1
      ) &&
      shouldProductBeVisible(product) &&
      product.state === "published"
    );
  });
};

const getPriceFromProduct = (product: Product): number => {
  const propertyConfig = product.propertyConfigs[0];
  if (typeof propertyConfig?.customPriceCents === "number") return propertyConfig.customPriceCents;
  return product.retailPriceCents;
};

const shouldProductBeVisible = (product: Product) =>
  product.propertyConfigs.length === 0 ||
  product.propertyConfigs[0].shopConfigs.length === 0 ||
  (product.propertyConfigs[0].shopConfigs[0].visible && product.state === "published");

export { filterProductsBySearchInput, getPriceFromProduct, shouldProductBeVisible };
